<template>
  <div class="create">
    <form-title>行业信息</form-title>
    <info-panel>
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="90px"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="行业名称"
              prop="evaluationName"
            >
              <el-input v-model="createForm.evaluationName" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="价格"
              prop="price"
            >
              <el-input
                v-model="createForm.price"
                class="append-unit"
              >
                <template
                  slot="append"
                >
                  元
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="分销金额"
              prop="distributionAmount"
            >
              <el-input
                v-model="createForm.distributionAmount"
                class="append-unit"
              >
                <template
                  slot="append"
                >
                  元
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="虚拟价格标签"
              prop="priceTag"
              class="input-flex"
            >
              <el-input v-model="createForm.priceTag" />
              <el-tooltip
                effect="dark"
                content="虚拟价格生效，虚拟价格标签不能为空"
                placement="top-start"
              >
                <i class="el-icon-question" />
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="虚拟价格"
              prop="fakePrice"
            >
              <el-input
                v-model="createForm.fakePrice"
                class="append-unit"
              >
                <template
                  slot="append"
                >
                  元
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="虚拟购买数量"
              prop="virtualBuyCount"
            >
              <el-input
                v-model="createForm.virtualBuyCount"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="排序值"
              prop="rank"
            >
              <el-input v-model="createForm.rank" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item
              label="行业介绍"
              prop="evaluationDesc"
            >
              <editor :html.sync="createForm.evaluationDesc" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item
              label="抽奖活动规则"
              prop="lotteryRuleIntro"
            >
              <editor :html.sync="createForm.lotteryRuleIntro" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </info-panel>
    <el-row
      :gutter="20"
      class="submit"
    >
      <el-col class="btns">
        <el-button @click="cancel">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="submit"
        >
          保存
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import axClient from '@/services';
import infoPanel from '@/components/common/infoPanel.vue';
import formTitle from '@/components/common/formTitle.vue';
import Editor from '@/components/common/editor.vue';

export default {
  name: 'AgencyEdit',
  components: {
    formTitle,
    infoPanel,
    Editor,
  },
  data() {
    return {
      createForm: {
        id: '',
        evaluationName: '', // 行业名称
        price: 0, // 价格
        fakePrice: 0, // 虚拟价格
        priceTag: '', // 虚拟价格标签
        virtualBuyCount: 0, // 虚拟购买数量
        distributionAmount: 0, // 分销金额
        rank: '', // 排序值
        lotteryRuleIntro: null, // 抽奖活动规则
        businessLicense: null, // 行业介绍
      },
      creatRules: {
        evaluationName: [
          { required: true, message: '请输入行业名称', trigger: 'blur' },
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' },
        ],
        distributionAmount: [
          { required: true, message: '请输入分销金额', trigger: 'blur' },
        ],
      },
      result: {},
      isEditType: !!this.$route.params.id,
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    // 取消
    cancel() {
      window.history.back();
    },
    // 提交
    async submit() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const {
            evaluationName,
            priceTag,
            virtualBuyCount,
            rank,
            lotteryRuleIntro,
            evaluationDesc,
            id,
            price,
            fakePrice,
            distributionAmount,
          } = this.createForm;
          const data = await axClient.evaluation.evaluationUpsert({
            evaluationName,
            priceTag,
            virtualBuyCount,
            rank,
            lotteryRuleIntro,
            evaluationDesc,
            id,
            price: price * 100,
            fakePrice: fakePrice * 100,
            distributionAmount: distributionAmount * 100,
          });
          if (data) {
            if (this.isEditType) {
              this.$message.success('编辑行业成功');
            } else {
              this.$message.success('新增行业成功');
            }
            this.$router.push({ name: 'EvaluationList' });
          }
        }
      });
    },
    // 是否编辑信息
    async getInfo() {
      if (this.isEditType) {
        // 编辑
        this.result = await axClient.evaluation.evaluationgetDetail({ id: this.$route.params.id });
        const {
          evaluationName,
          priceTag,
          virtualBuyCount,
          rank,
          lotteryRuleIntro,
          evaluationDesc,
          id,
          price,
          fakePrice,
          distributionAmount,
        } = this.result;

        this.createForm = {
          id,
          evaluationName,
          priceTag,
          virtualBuyCount,
          rank,
          lotteryRuleIntro,
          evaluationDesc,
          price: price / 100,
          fakePrice: fakePrice / 100,
          distributionAmount: distributionAmount / 100,
        };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.submit {
  text-align: center;
  margin-top: 20px
}
</style>